import React, { useState } from "react";
import Layout from "../../component/Layout";
import { Header } from "../../component/Header";
import speedstep2 from "../../images/speedstep2.png";
import workout from "../../images/workout.png";
import lady from "../../images/lady.png";
import video from "../../images/video.svg";
import plus from "../../images/plus.svg";
import upload from "../../images/upload.svg";
import greenClock from "../../images/greenClock.svg";

const SpeedStep = () => {
  const [activeTab, setActiveTab] = useState("Warmup Routine");
  const [selectedItem, setSelectedItem] = useState(null); // Selected item for details view
  const [isDetailsView, setIsDetailsView] = useState(false); // Toggle between tabs and details view
  const [speedWorkout, setSpeedWorkout] = useState<number | null>(null);

  const wormupRoutineData = [
    { id: 1, label: "Soft Tissue" },
    { id: 2, label: "Mobility" },
    { id: 3, label: "Soft Tissue" },
    { id: 4, label: "Soft Tissue" },
    { id: 5, label: "Mobility" },
    { id: 6, label: "Soft Tissue" },
    { id: 7, label: "Mobility" },
    { id: 8, label: "Soft Tissue" },
    { id: 9, label: "Mobility" },
    { id: 10, label: "Soft Tissue" },
    { id: 11, label: "Mobility" },
  ];
  const handleChangeTab = (item: any) => {
    setActiveTab(item);
  };
  const handleItemClick = (item: any) => {
    setSelectedItem(item);
    setIsDetailsView(true);
  };
  const handleBackToTabs = () => {
    setSelectedItem(null);
    setIsDetailsView(false);
  };

  const handleBackToMainTabbing = () => {
    setSelectedItem(null);
  };
  const handleAccordionClick = (index: number) => {
    setSpeedWorkout(speedWorkout === index ? null : index);
  };
  return (
    <Layout>
      <div className="bg-white">
        <Header />
      </div>
        <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
          <ArrowL />
          <p className="text-black text-xl font-normal">Monday, Nov 6</p>
          <ArrowG />
        </div>
        <div className="w-full max-w-2xl mx-auto h-full bg-black">
          <div className=" text-white py-3 bg-black">
            <div className="flex justify-between gap-[68px] mb-4 px-5">
              <button
                onClick={() => handleChangeTab("Warmup Routine")}
                className={`${
                  activeTab === "Warmup Routine"
                    ? "text-white border-b-2 border-white"
                    : "text-[#5d5d5d]"
                } text-base pb-2 font-normal `}
              >
                Warmup Routine
              </button>
              <button
                onClick={() => handleChangeTab("Speed Workout")}
                className={`${
                  activeTab === "Speed Workout"
                    ? "text-white border-b-2 border-white"
                    : "text-[#5d5d5d]"
                } text-base pb-2 font-normal `}
              >
                Speed Workout
              </button>
            </div>
            {activeTab === "Warmup Routine" ? (
              <>
                {selectedItem ? (
                  <>
                    <SpeedStep2
                      selectedItem={selectedItem}
                      details={details}
                      handleBackToMainTabbing={handleBackToMainTabbing}
                    />
                  </>
                ) : (
                  <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
                    {wormupRoutineData.map((item) => (
                      <button
                        key={item.id}
                        className="w-full p-[14px] text-white font-normal border border-white/20 bg-transparent rounded-[15px] hover:bg-white/10 transition text-start"
                        onClick={() => handleItemClick(item)}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <>
                <SpeedStep3
                  speedWorkout={speedWorkout}
                  handleAccordionClick={handleAccordionClick}
                />
              </>
            )}
          </div>
        </div>
      {/* </div> */}
    </Layout>
  );
};

export default SpeedStep;

const ArrowLWhite = () => {
  return (
    <svg
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ArrowL = () => {
  return (
    <svg
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ArrowG = () => {
  return (
    <svg
      className="hover:opacity-50  cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ArrowWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        d="M1 0.999999L7 7L13 1"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
// warmup routine
const SpeedStep2 = ({
  selectedItem,
  details,
  handleBackToMainTabbing,
}: any) => {
  if (!selectedItem) {
    return null; // Render nothing or a fallback UI if selectedItem is null
  }
  return (
    <>
      <div className="w-full text-center relative">
        <span
          className="absolute left-5 top-1/2 -translate-y-1/2"
          onClick={handleBackToMainTabbing}
        >
          <ArrowLWhite />
        </span>
        <p className="text-white text-base font-normal inline-flex">
          {selectedItem.label}
        </p>
      </div>
      {/* Details Content */}
      <div className="space-y-[15px] h-full overflow-hidden overflow-y-auto mt-[22px] px-5">
        {details.map((item: any) => (
          <div
            key={item.id}
            className="flex flex-row justify-between items-center pb-[15px] border-b border-white/20"
          >
            <div className="flex flex-col gap-2">
              <p className="text-white text-base font-normal leading-[95%]">
                {item.name}
              </p>
              <span className="text-white text-[13px] font-light">
                {item.time}
              </span>
            </div>
            {item.path ? (
              <img
                src={item.path}
                alt="image"
                className="w-[36px] h-[36px] rounded-[5px]"
              />
            ) : null}
          </div>
        ))}
      </div>
    </>
  );
};
// speed workout
const SpeedStep3 = ({ speedWorkout, handleAccordionClick }: any) => {
  return (
    <>
      <div>
        <div
          className={`${
            speedWorkout !== null ? "hidden" : "block"
          }  relative after:bg-gradient-to-b after:from-black/0 after:from-50% after:to-black/40 after:to-80% after:absolute after:bottom-0 after:w-full after:h-full`}
        >
          <img
            src={workout}
            alt="workout"
            className={`w-full h-[204px] ${
              speedWorkout !== null ? "hidden" : "block"
            }`}
          />
          <div
            className={`flex justify-between items-center text-white p-5 w-full absolute bottom-5 z-10`}
          >
            <p className=" text-xl font-normal">Short Sprinter</p>
            <p className=" text-sm font-normal">1,050m</p>
          </div>
        </div>
        <div
          className={`${
            speedWorkout !== null ? "block" : "hidden"
          } p-[20px_20px_40px_20px] flex justify-between items-center text-black bg-white`}
        >
          <p className="text-xl font-normal">Short Sprinter</p>
          <p className="text-sm font-normal">1,050m</p>
        </div>
        <div className="flex flex-col px-5 !rounded-t-[20px] -mt-5 relative z-10 bg-black">
          {speedWorkoutData.map((item, index) => (
            <div
              key={index}
              className="bg-transparent py-5 border-b border-white/20"
            >
              <div
                className="flex flex-row justify-between items-center text-center cursor-pointer"
                onClick={() => handleAccordionClick(index)}
              >
                <div className="space-y-2">
                  <label className="text-[#a5a5a5] text-xs font-normal uppercase">Sets</label>
                  <p>{item.sets}</p>
                </div>
                <div className="space-y-2">
                  <label className="text-[#a5a5a5] text-xs font-normal uppercase">Reps</label>
                  <p>{item.reps}</p>
                </div>
                <div className="space-y-2">
                  <label className="text-[#a5a5a5] text-xs font-normal uppercase">Distance</label>
                  <p>{item.distance}</p>
                </div>
                <div className="space-y-2">
                  <label className="text-[#a5a5a5] text-xs font-normal uppercase">T/T</label>
                  <p>{item.time}</p>
                </div>
                <span className="cursor-pointer">
                  <ArrowWhite />
                </span>
              </div>
              {speedWorkout === index && (
                <>
                  <div className="text-white text-sm font-normal mt-3">
                    <p>
                      <span className="uppercase">Rest: </span> {item.rest}
                    </p>
                    <p className="mt-3">
                      <span className="uppercase">Notes: </span> {item.notes}
                    </p>
                    <p className="mt-3">
                      <span>Sprintouts:</span> {item.sprintouts}
                    </p>
                    <p className="mt-3">
                      <span>Workout:</span> {item.workout}
                    </p>
                    <button className="border border-white py-6 px-10 w-full max-w-sm mx-auto rounded-[70px] block my-[30px] uppercase font-semibold">
                      Message the Coach
                    </button>
                  </div>
                  <div className="w-full flex flex-row gap-[15px] mb-[15px]">
                    <div className="w-1/2 h-[120px] border border-white/10 rounded-[15px] overflow-hidden">
                      <img
                        src={lady}
                        alt="lady"
                        className="object-cover w-full"
                      />
                    </div>
                    <div className="w-1/2 h-[120px] border border-white/10 p-[15px] rounded-[15px] overflow-hidden">
                      <img
                        src={video}
                        alt="video"
                        className="object-contain mb-6 cursor-pointer"
                      />
                      <p className="text-white text-sm font-normal mb-3">
                        Upload video
                      </p>
                      <img
                        src={upload}
                        alt="upload"
                        className="object-contain cursor-pointer"
                      />
                    </div>
                  </div>
                  <div className="p-[19px] flex justify-between items-center">
                    <p className="text-xl font-normal">30 sec</p>
                    <img
                      src={greenClock}
                      alt="greenClock"
                      className="object-contain cursor-pointer"
                    />
                  </div>
                  <div className="p-[19px] flex justify-between items-center">
                    <div className="relative w-full">
                      <input
                        type="text"
                        className="placeholder:text-[#5D5D5D] placeholder:font-medium text-white text-xl font-normal bg-transparent w-full outline-none pr-12"
                        placeholder="Actual time"
                      />
                      <img
                        src={plus}
                        alt="plus"
                        className="absolute right-0 top-1/2 -translate-y-1/2"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const details = [
  { id: 1, name: "Exercise Name", time: "10 minutes", path: speedstep2 },
  { id: 2, name: "Exercise Name", time: "10 minutes", path: speedstep2 },
  { id: 3, name: "Exercise Name", time: "10 minutes", path: speedstep2 },
  { id: 4, name: "Exercise Name", time: "10 minutes", path: "" },
  { id: 5, name: "Exercise Name", time: "10 minutes", path: speedstep2 },
  { id: 6, name: "Exercise Name", time: "10 minutes", path: "" },
  { id: 7, name: "Exercise Name", time: "10 minutes", path: speedstep2 },
];
const speedWorkoutData = [
  {
    sets: 1,
    reps: 3,
    distance: "250m",
    time: "21.0",
    rest: "6m rest between reps, 8m between sets",
    notes: "Warm Up: Series A with Bands",
    sprintouts:
      "Do 2 sprintouts to top speed before the wickets and rest about 3m before starting wickets",
    workout:
      "250m focus on getting out for the first 150m then stop pushing and keep momentum while staying relaxed. At the 200m mark start running up hill driving arms back further and more aggressively.",
  },
  {
    sets: 1,
    reps: 3,
    distance: "250m",
    time: "21.0",
    rest: "6m rest between reps, 8m between sets",
    notes: "Warm Up: Series A with Bands",
    sprintouts:
      "Do 2 sprintouts to top speed before the wickets and rest about 3m before starting wickets",
    workout:
      "250m focus on getting out for the first 150m then stop pushing and keep momentum while staying relaxed. At the 200m mark start running up hill driving arms back further and more aggressively.",
  },
  {
    sets: 1,
    reps: 3,
    distance: "250m",
    time: "21.0",
    rest: "6m rest between reps, 8m between sets",
    notes: "Warm Up: Series A with Bands",
    sprintouts:
      "Do 2 sprintouts to top speed before the wickets and rest about 3m before starting wickets",
    workout:
      "250m focus on getting out for the first 150m then stop pushing and keep momentum while staying relaxed. At the 200m mark start running up hill driving arms back further and more aggressively.",
  },
];
